export enum ConfirmationActions {
    ACCEPT = "ACCEPT",
    REJECT = "REJECT",
}